import CryptoJS from 'crypto-js'
import moment from 'moment'

function getDateAsHex() {
  const date = moment().format('YYYYMMDD')
  return CryptoJS.enc.Utf8.parse(date).toString(CryptoJS.enc.Hex)
}

function generateSecretKey() {
  const dateHex = getDateAsHex()
  const secretKeyPrefix =
    process.env.REACT_APP_ENCRYPT_SECRET_KEY || 'ENCRYPT_SECRET_KEY'

  const secretKey = secretKeyPrefix + dateHex

  return CryptoJS.enc.Utf8.parse(secretKey).toString(CryptoJS.enc.Hex).slice(0, 64)
}

function encryptAes256CBC(text) {
  const key = CryptoJS.enc.Hex.parse(generateSecretKey())
  const iv = CryptoJS.lib.WordArray.random(16)

  const encrypted = CryptoJS.AES.encrypt(text, key, {
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  })

  return {
    idEn: iv.toString(CryptoJS.enc.Hex),
    dataEn: encrypted.ciphertext.toString(CryptoJS.enc.Hex)
  }
}

function decryptAes256CBC(encryptedData) {
  const key = CryptoJS.enc.Hex.parse(generateSecretKey())
  const iv = CryptoJS.enc.Hex.parse(encryptedData.idEn)

  const decrypted = CryptoJS.AES.decrypt(
    { ciphertext: CryptoJS.enc.Hex.parse(encryptedData.dataEn) },
    key,
    {
      iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    }
  )

  return JSON.parse(decrypted.toString(CryptoJS.enc.Utf8))
}

export { encryptAes256CBC, decryptAes256CBC }